import { useContext } from 'react';
import { useTheme } from 'styled-components';

import { mapStyledProps, SizeProps } from '../../styles';
import { getPxValue } from '../../utils';
import { DropdownListItem, DropdownOption } from '../Dropdown';
import List from '../List';

import { FlatDropdownContext } from './context';
import { Content } from './FlatDropdown.styled';
import { FlatDropdownChangeEventHandler } from './types';

type Props = SizeProps & {
  selectedValue?: string;
  options: DropdownOption[];
  onChange: FlatDropdownChangeEventHandler;
};

const FlatDropdownContent = ({
  options,
  onChange,
  selectedValue,
  ...rest
}: Props) => {
  const theme = useTheme();

  const { setIsOpen } = useContext(FlatDropdownContext);

  const sideOffset = getPxValue(theme.components.FlatDropdown.regular.stack);

  return (
    <Content sideOffset={sideOffset} {...mapStyledProps(rest)}>
      <List>
        {options.map(item => (
          <DropdownListItem
            isDisabled={item.isDisabled}
            isSelected={item.value === selectedValue}
            key={item.key || `${item.label}-${item.value}`}
            left={item.icon}
            onClick={e => {
              onChange(item, e);

              if (e.isDefaultPrevented()) {
                return;
              }

              setIsOpen?.(false);
            }}>
            {item.label}
          </DropdownListItem>
        ))}
      </List>
    </Content>
  );
};

export default FlatDropdownContent;
